/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentFeature } from './DocumentFeature';
import {
	DocumentFeatureFromJSON,
	DocumentFeatureFromJSONTyped,
	DocumentFeatureToJSON,
	DocumentFeatureToJSONTyped,
} from './DocumentFeature';
import type { ValidationResult } from './ValidationResult';
import {
	ValidationResultFromJSON,
	ValidationResultFromJSONTyped,
	ValidationResultToJSON,
	ValidationResultToJSONTyped,
} from './ValidationResult';

/**
 *
 * @export
 * @interface DocumentAddCommandResultValidationResult
 */
export interface DocumentAddCommandResultValidationResult {
	/**
	 *
	 * @type {DocumentFeature}
	 * @memberof DocumentAddCommandResultValidationResult
	 */
	feature?: DocumentFeature;
	/**
	 *
	 * @type {ValidationResult}
	 * @memberof DocumentAddCommandResultValidationResult
	 */
	validationResult?: ValidationResult;
	/**
	 *
	 * @type {string}
	 * @memberof DocumentAddCommandResultValidationResult
	 */
	title?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof DocumentAddCommandResultValidationResult
	 */
	description?: string | null;
}

/**
 * Check if a given object implements the DocumentAddCommandResultValidationResult interface.
 */
export function instanceOfDocumentAddCommandResultValidationResult(
	value: object
): value is DocumentAddCommandResultValidationResult {
	return true;
}

export function DocumentAddCommandResultValidationResultFromJSON(
	json: any
): DocumentAddCommandResultValidationResult {
	return DocumentAddCommandResultValidationResultFromJSONTyped(json, false);
}

export function DocumentAddCommandResultValidationResultFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): DocumentAddCommandResultValidationResult {
	if (json == null) {
		return json;
	}
	return {
		feature: json['feature'] == null ? undefined : DocumentFeatureFromJSON(json['feature']),
		validationResult:
			json['validationResult'] == null
				? undefined
				: ValidationResultFromJSON(json['validationResult']),
		title: json['title'] == null ? undefined : json['title'],
		description: json['description'] == null ? undefined : json['description'],
	};
}

export function DocumentAddCommandResultValidationResultToJSON(
	json: any
): DocumentAddCommandResultValidationResult {
	return DocumentAddCommandResultValidationResultToJSONTyped(json, false);
}

export function DocumentAddCommandResultValidationResultToJSONTyped(
	value?: DocumentAddCommandResultValidationResult | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		feature: DocumentFeatureToJSON(value['feature']),
		validationResult: ValidationResultToJSON(value['validationResult']),
		title: value['title'],
		description: value['description'],
	};
}
